export default __webpack_public_path__ + "8f953a9418c323f01f2c90b33b2c099a.png";